export default class CredentialError extends Error {
  constructor (errors) {
    super('Credential error');
    this.errors = errors;
  //  Error.captureStackTrace(this, this.constructor);
    this.name = this.constructor.name;

    return this;
  }
}
